import React from "react";

const EmptySupplementalData = () => {
  return <></>;
};

export default EmptySupplementalData;
